"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("../../../lib/core"));

var _request = _interopRequireDefault(require("../../../lib/request"));

var _company = _interopRequireDefault(require("./classes/company"));

var _company_invite = _interopRequireDefault(require("./classes/company_invite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var company = /*#__PURE__*/function () {
  function company() {
    _classCallCheck(this, company);
  }

  _createClass(company, null, [{
    key: "current",
    get: function get() {
      return _core["default"].store.get('core:company:current');
    },
    set: function set(value) {
      return _core["default"].store.set('core:company:current', value);
    } // Install

  }, {
    key: "install",
    value: function install(Vue) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Set options
      _company["default"].uri = options.uri || _company["default"].uri;
      _company_invite["default"].uri = "".concat(_company["default"].uri, "/invite"); // Set getPermissionsOnEvent to company

      if (_core["default"].permissions.enabled === true) {
        _core["default"].permissions.getPermissionsOnEvent = 'company';
      } // Add company to query


      _request["default"].beforeRequest(function (_method, _url) {
        var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        if (options.skip_company !== true && company.current) {
          if (!data.query) data.query = {};
          data.query.company = company.current._meta.guid;
        }
      }); // Listen to 'auth' and remove company when authenticated changed to false


      _core["default"].eventhub.on('core:auth:authenticated', function (authenticated) {
        // Remove store on logout
        if (authenticated === false && company.current) {
          company.removeCompany();
        }
      }); // Listen to websocket state change


      _core["default"].eventhub.on("core:ws:".concat(_core["default"].ws.uri, ":state"), function (state, oldState) {
        // Get session again on reconnection
        if (state === true && oldState === false) {
          _this.getSession({
            force_update: true
          });
        }
      });
    } // Methods

  }, {
    key: "setCompany",
    value: function () {
      var _setCompany = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var guid,
            options,
            companyDocument,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                guid = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!(guid === null)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.removeCompany());

              case 4:
                _context.prev = 4;
                _context.next = 7;
                return _core["default"].ws.get("".concat(_company["default"].uri, "/resource/").concat(guid));

              case 7:
                companyDocument = _context.sent;
                company.current = new _company["default"]().merge(companyDocument); // Get permissions, if enabled

                if (!(_core["default"].permissions.enabled === true && _core["default"].permissions.getPermissionsOnEvent === 'company')) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return _core["default"].permissions.getPermissions();

              case 12:
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](4);
                console.error('[company]', 'error loading company', _context.t0);
                company.removeCompany();
                throw _context.t0;

              case 19:
                _core["default"].eventhub.emit('core:company:current', company.current, {
                  force_update: options.force_update === true
                });

                window.sessionStorage.setItem(company.sessionDocument, company.current._meta.guid);
                return _context.abrupt("return", company.current);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 14]]);
      }));

      function setCompany() {
        return _setCompany.apply(this, arguments);
      }

      return setCompany;
    }()
  }, {
    key: "removeCompany",
    value: function () {
      var _removeCompany = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                company.current = null;
                window.sessionStorage.removeItem(company.sessionDocument);

                _core["default"].eventhub.emit('core:company:current', null);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function removeCompany() {
        return _removeCompany.apply(this, arguments);
      }

      return removeCompany;
    }()
  }, {
    key: "getSession",
    value: function () {
      var _getSession = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var options,
            guid,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                guid = window.sessionStorage.getItem(company.sessionDocument);

                if (guid) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", null);

              case 4:
                if (!(options.force_update !== true && company.sessionPromise)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", company.sessionPromise);

              case 6:
                company.sessionPromise = company.setCompany(guid, options);
                _context3.next = 9;
                return company.sessionPromise;

              case 9:
                company.sessionPromise = null;
                return _context3.abrupt("return", company.current);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getSession() {
        return _getSession.apply(this, arguments);
      }

      return getSession;
    }()
  }]);

  return company;
}();

exports["default"] = company;
company.sessionDocument = 'company';
company.sessionPromise = null;